import type { RootState } from 'store/root/reducers';

const getCurrentState = (state: RootState) => state['notification'];

const notificationSelectors = {
  notifications: (state: RootState) => getCurrentState(state).notifications,
  unreadCount: (state: RootState) => getCurrentState(state).unreadCount,
};

export default notificationSelectors;
